import { createAction, props } from '@ngrx/store';

export const LoadProvisioningStatus = createAction(
  '[Provisioning] Load Provisioning Status'
);

export const LoadProvisioningStatusSuccess = createAction(
  '[Provisioning] Load Provisioning Status Success',
  props<{ active: boolean }>()
);

export const LoadProvisioningStatusFailure = createAction(
  '[Provisioning] Load Provisioning Status Failure',
  props<{ error: any }>()
);

export const SwitchProvisioningStatus = createAction(
  '[Provisioning] Switch Provisioning'
);

export const SwitchProvisioningStatusSuccess = createAction(
  '[Provisioning] Switch Provisioning Success',
  props<{ active: boolean }>()
);

export const SwitchProvisioningStatusFailure = createAction(
  '[Provisioning] Switch Provisioning Failure',
  props<{ error: any }>()
);

export const ActivateProvisioning = createAction(
  '[Provisioning] Activate Provisioning'
);

export const ActivateProvisioningSuccess = createAction(
  '[Provisioning] Activate Provisioning Success'
);

export const ActivateProvisioningFailure = createAction(
  '[Provisioning] Activate Provisioning Failure',
  props<{ error: any }>()
);

export const DeactivateProvisioning = createAction(
  '[Provisioning] Deactivate Provisioning'
);

export const DeactivateProvisioningSuccess = createAction(
  '[Provisioning] Deactivate Provisioning Success'
);

export const DeactivateProvisioningFailure = createAction(
  '[Provisioning] Deactivate Provisioning Failure',
  props<{ error: any }>()
);

export const GenerateSCIMToken = createAction(
  '[Provisioning] Genrate SCIM Token'
);

export const GenerateSCIMTokenSuccess = createAction(
  '[Provisioning] Genrate SCIM Token Success',
  props<{ token: string }>()
);

export const GenerateSCIMTokenFailure = createAction(
  '[Provisioning] Genrate SCIM Token Failure',
  props<{ error: any }>()
);

export const ResetProvisioning = createAction(
  '[Provisioning] Reset Provisioning'
);

export const ResetProvisioningSuccess = createAction(
  '[Provisioning] Reset Provisioning Success'
);

export const ResetProvisioningFailure = createAction(
  '[Provisioning] Reset Provisioning Failure',
  props<{ error: any }>()
);

export const DeleteDisabledUsers = createAction(
  '[Provisioning] Delete Disabled Users'
);

export const DeleteDisabledUsersSuccess = createAction(
  '[Provisioning] Delete Disabled Users Success',
  props<{ deletedUserCount: number }>()
);

export const DeleteDisabledUsersFailure = createAction(
  '[Provisioning] Delete Disabled Users Failure',
  props<{ error: any, code: any }>()
);

export const ResetDeleteDisabledUsers = createAction(
  '[Provisioning] Reset Delete Disabled Users'
)


export const ListDisabledUsersToDelete = createAction(
  '[Provisioning] List Disabled Users to Delete '
);

export const ListDisabledUsersToDeleteSuccess = createAction(
  '[Provisioning] List Disabled Users to Delete  Success',
  props<{ disabledUsersToDelete: number }>()
);

export const ListDisabledUsersToDeleteFailure = createAction(
  '[Provisioning] List Disabled Users to Delete  Failure',
  props<{ error: any }>()
);